module.exports = __webpack_public_path__ + "img/35.200a2705.png";